import classNames from 'classnames';

import styles from './ToggleGroup.module.scss';

export type ToggleGroupOption<T extends string> = {
  label: string;
  value: T;
  icon: React.ReactNode;
};

interface ToggleGroupProps<T extends string> {
  name: string;
  legend: string;
  options: ToggleGroupOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

const ToggleGroup = <T extends string>({ name, legend, value, options, onChange }: ToggleGroupProps<T>) => {
  const activeIndex = options.findIndex((o) => o.value === value);

  return (
    <fieldset className={styles.group} role="radiogroup">
      <legend className={styles.srOnly}>{legend}</legend>

      {/* animated highlight */}
      <div
        className={styles.highlight}
        style={{
          width: `${100 / options.length}%`,
          transform: `translateX(${activeIndex * 100}%)`,
        }}
      />

      {options.map((option) => {
        const id = `${name}-${option.value}`;

        return (
          <div key={option.value} className={classNames(styles.option, { [styles.active]: value === option.value })} title={option.label}>
            <input
              id={id}
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className={styles.radio}
            />

            <label htmlFor={id} className={styles.label}>
              {option.icon}
              <span className={styles.innerLabel} data-label={option.label}>
                {option.label}
              </span>
            </label>
          </div>
        );
      })}
    </fieldset>
  );
};

export default ToggleGroup;
